<template>
  <div class="plv-ia-timer-num-panel" :class="{ 'plv-ia-timer-num-panel--blink': blink }">
    <div v-if="!readonly" class="plv-ia-timer-num-op plv-ia-timer-num-op-add" @click="handleAddOrDel(1)"></div>
    <div class="plv-ia-timer-num-input">
      <div class="plv-ia-timer-num-input__wrap">
        <input
          v-if="!readonly"
          ref="input"
          :value="value"
          type="text"
          @blur="handleBlur"
          @input="handleInput"
        />
        <div
          v-else
          :class="['plv-ia-timer-num-input-readonly', {
            'plv-ia-timer-num-input-readonly--danger': isDanger
          }]"
        >
          {{ value }}
        </div>
      </div>
    </div>
    <div v-if="!readonly" class="plv-ia-timer-num-op plv-ia-timer-num-op-del" @click="handleAddOrDel(0)"></div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: {
      type: [String, Number],
      default: 0,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    max: {
      type: Number,
      default: 9,
    },

    blink: {
      type: Boolean,
      default: false,
    },

    isDanger: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {};
  },

  methods: {
    handleAddOrDel(isAdd) { // type 为 1(add) / 0(del)
      const curNum = this.value;
      const newNum = isAdd ? (curNum >= this.max ? 0 : curNum + 1) : (curNum <= 0 ? this.max : curNum - 1);
      this.$emit('input', newNum);
    },

    handleBlur(e) {
      this.showInput = false;
      if (!e.target.value || isNaN(e.target.value)) this.$emit('input', 0);
    },

    handleInput(e) {
      let newNum = Number(e.target.value.replace(/\D/, '').replace(/^0+/, '').slice(-1));

      if (isNaN(newNum) || newNum > this.max) {
        newNum = 0;
      }
      e.target.value = newNum;
      this.$emit('input', newNum);
    },

    handleShowInput() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};
</script>

<style lang="scss">
@mixin alibaba-font($font-size: 12px, $font-weight: normal) {
  font: $font-weight $font-size ALIBABAFont, $mobile-font;
}

@mixin num-panel-bg($is-focus: false) {
  border-radius: 4px;
  @if $is-focus {
    background: linear-gradient(135deg, #0F0F14 0%, #5F5F72 100%);
    box-shadow: inset -2px -2px 6px 0 rgba(255, 255, 255, 0.1), inset 2px 2px 6px 0 rgba(26, 27, 31, 0.3);
  } @else {
    background: linear-gradient(180deg, #727287 0%, #3E3E4F 100%);
    box-shadow: inset 0 1px 1px 0 rgba(255, 255, 255, 0.21), inset 0 0 2px 0 rgba(39, 40, 50, 0.35);
  }
}

@keyframes blink {
  50% {
    color: #fff;
  }
}

.plv-ia-timer-num-panel {
  position: relative;
  padding: 18px 0;

  &+.plv-ia-timer-num-panel {
    margin-left: 10px;
  }
}

.plv-ia-timer-num-op {
  height: 6px;
  padding: 8px 0 4px;
  margin-bottom: 4px;
  cursor: pointer;
  position: absolute;
  width: 100%;
  left: 0;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
  }
}
.plv-ia-timer-num-op-add {
  top: 0;
}
.plv-ia-timer-num-op-add::before {
  border-top: 6px solid transparent;
  border-bottom: 6px solid #ADADC0;
  top: 2px;
}
.plv-ia-timer-num-op-del {
  bottom: 0;
}
.plv-ia-timer-num-op-del::before {
  border-bottom: 6px solid transparent;
  border-top: 6px solid #ADADC0;
  top: 8px;
}

.plv-ia-timer-num-input {
  position: relative;
  overflow: hidden;
  width: 50px;
  line-height: 56px;
  height: 56px;
  padding: 3px;
  border-radius: 4px;
  border: 1px solid #3E3E4F;
  box-sizing: border-box;
}
.plv-ia-timer-num-input__wrap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  @include num-panel-bg();
}
.plv-ia-timer-num-input input, .plv-ia-timer-num-input-readonly {
  @include alibaba-font(44px, bold);
  outline: 0;
  border: 0;
  width: 100%;
  height: 100%;
  line-height: 48px;
  color: #fff;
  text-align: center;
  background-color: transparent;
  user-select: none;
  margin-top: -1px;

  &:not([readonly]):focus {
    @include num-panel-bg(true);
  }

  &[readonly] {
    cursor: default;
  }
}

.plv-ia-timer-num-input-readonly--danger {
  color: #FF5B5B;
}

.plv-ia-timer-num-panel--blink {
  .plv-ia-timer-num-input input, .plv-ia-timer-num-input-readonly {
    animation: blink 0.2s steps(1) infinite;
  }
}
</style>
